export const Timezones = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
  "America/Toronto",
  "America/Winnipeg",
  "America/Edmonton",
  "America/Vancouver",
  "America/Halifax",
  "America/St_Johns",
  "America/Whitehorse",
  "America/Iqaluit",
];

export const TimezoneAbbreviations: { [key: string]: string } = {
  "America/New_York": "ET - Eastern Time",
  "America/Chicago": "CT - Central Time",
  "America/Denver": "MT - Mountain Time",
  "America/Phoenix": "MST - Mountain Standard Time (Arizona)",
  "America/Los_Angeles": "PT - Pacific Time",
  "America/Anchorage": "AKT - Alaska Time",
  "Pacific/Honolulu": "HST - Hawaii Standard Time",

  "America/Toronto": "ET - Canada Toronto",
  "America/Winnipeg": "CT - Canada",
  "America/Edmonton": "MT - Canada",
  "America/Vancouver": "PT - Canada Vancouver",
  "America/Halifax": "AT - Canada",
  "America/St_Johns": "NT - Canada St. John's",
  "America/Whitehorse": "PT - Canada Whitehorse",
  "America/Iqaluit": "ET - Canada Iqaluit",
};
